<template>

  <v-text-field v-bind="{ ...$attrs, ...commonAttrs }" :autocomplete="autocomplete" @wheel="preventNumberScroll($event)">

    <!-- https://stackoverflow.com/a/71678136/19018560 -->
    <template v-for="(_, name) in $slots" #[name]="slotData">
      <slot :name="name" v-bind="slotData || {}" />
    </template>

  </v-text-field>

</template>

<script>
// https://vuejs.org/guide/components/attrs.html#disabling-attribute-inheritance
export default {
  inheritAttrs: false
}
</script>

<script setup>

/**
 * A simple wrapper for Vuetify's <v-text-field>.
 * 
 * https://dev.to/kouts/create-wrapper-components-for-vuetify-components-2aah
 * https://v3-migration.vuejs.org/breaking-changes/listeners-removed.html
 */

import { computed, useAttrs } from 'vue'

const props = defineProps({

  validator: {
    type: Object,
  },

  required: {
    type: Boolean,
    default: false,
  },

  autocomplete: {
    type: String,
    default: 'off',
  },

})

const attrs = useAttrs()

const commonAttrs = computed(() => {

  const output = {}

  if (props.validator) {
    output.validator = null // don't pass the validator prop along to v-text-field
    output.errorMessages = props.validator.$errors.map(e => e.$message)
  }

  // If the readonly prop was passed, automatically use the plain variant
  if ('readonly' in attrs && (!!attrs.readonly || attrs.readonly === '')) {
    output.variant = 'plain'
  }

  if (props.required) {
    if ('class' in attrs) {
      output.class = attrs.class + ' v-input--required'
    } else {
      output.class = 'v-input--required'
    }
  }

  return output

})

// TODO: make this into a composable, so we can reuse it?
const isRequired = computed(() => {
  
  if (!props.validator) {
    return false
  }

  for (const [key, value] of Object.entries(props.validator)) {
    if (typeof value.$params !== 'undefined') {
      if ('type' in value.$params && value.$params.type === 'required') {
        return true
      }
    }
  }

  return false

})

function preventNumberScroll(e) {
  const hasFocus = e.target === document.activeElement
  if (hasFocus && attrs?.type === 'number') {
    // prevent the scroll wheel from changing the input value, because that's annoying
    e.target.blur()
    // refocus immediately, on the next tick (after the current function is done)
    setTimeout(() => {e.target.focus()}, 0)    
  }
}

</script>
